export default "__VITE_ASSET__d7900e26__"